import type {
  AdministratorsResponse,
  FamilyCheckRequest,
  MedicalAidPerson,
  PatientDetail,
  SubmitClaimRequest,
  SubmitClaimResult,
  SubmitClaimReversalRequest,
  SubmitClaimReversalResult,
} from '.';

export interface IHealthbridgeClient {
  generatedPatients?: Partial<MedicalAidPerson>[];
  queryFamilyCheck(
    request: FamilyCheckRequest,
  ): Promise<PatientDetail[] | undefined>;
  queryMedicalAidMembership(
    request: FamilyCheckRequest,
  ): Promise<Partial<MedicalAidPerson>[]>;
  queryMedicalAidMembershipForDependant(
    request: FamilyCheckRequest,
    dependantCode: string,
  ): Promise<Partial<MedicalAidPerson> | undefined>;
  getSchemes(): Promise<AdministratorsResponse | undefined>;
  submitClaim(claim: SubmitClaimRequest): Promise<SubmitClaimResult>;
  submitClaimReversal(
    claimReversal: SubmitClaimReversalRequest,
  ): Promise<SubmitClaimReversalResult>;
}
